import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { colors } from '../../theme/theme';
import { LinkedAssetResponse } from '../IMessageBubbleInterface';

import { AssetAvatarIcon, AssetCardShell, AssetFieldGrid, CardFollowUp, CardIntro } from './sharedCardHelpers';

export const LinkedAssetsCard: React.FC<{ linkedAssets: LinkedAssetResponse | null }> = ({ linkedAssets }) => {
    if (!linkedAssets) return null;

    return (
        <Box>
            <CardIntro text={linkedAssets.intro} />

            <Stack gap={0.9}>
                {linkedAssets.items.map((item, itemIdx) => {
                    // Only show tiles that actually carry a value. The "serial for name" format has
                    // no make/model/year/location, so suppressing empties avoids a wall of "N/A".
                    const detailTiles: Array<[string, string]> = [
                        ['Serial Number', item.serialNumber || 'N/A'],
                        ['Make', item.make],
                        ['Model', item.model],
                        ['Year', item.year],
                        ['Location', item.location],
                    ].filter(([, value]) => Boolean(value)) as Array<[string, string]>;

                    return (
                        <AssetCardShell key={`${item.serialNumber || item.name}-${itemIdx}`}>
                            <Stack direction="row" gap={0.85} alignItems="center" sx={{ mb: 0.95 }}>
                                <AssetAvatarIcon />

                                <Box sx={{ minWidth: 0 }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: colors.fullBlack,
                                            fontWeight: 700,
                                            fontSize: '0.95rem',
                                            lineHeight: 1.25,
                                        }}
                                    >
                                        {item.name || 'Asset'}
                                    </Typography>
                                </Box>
                            </Stack>

                            <AssetFieldGrid
                                keyPrefix={`${item.serialNumber || item.name}-${itemIdx}`}
                                fields={detailTiles}
                            />
                        </AssetCardShell>
                    );
                })}
            </Stack>

            <CardFollowUp text={linkedAssets.followUp} />
        </Box>
    );
};
